module.exports = __webpack_public_path__ + "static/media/29BDOS2.ba650a31.jpg";